import _ from 'lodash';
import appUrl from '../../../util/appUrl';
import ko, { Observable } from 'knockout';
import { showModalPage } from '../../../components/dialog/modal';

class Field {
	label: string;
	value: string;
}

export default class WorkItem {
	visible: Observable<boolean>;
	id: number;
	timecardEntry: number;
	setupIsVisible: boolean;
	productionIsVisible: boolean;
	teardownIsVisible: boolean;
	setupClass: string;
	productionClass: string;
	teardownClass: string;
	displayWorkOrder: string;
	setupUrl: string;
	productionUrl: string;
	teardownUrl: string;
	stopUrl: string;
	infoUrl: string;
	state: string;
	activeEmployees: any[];
	fields: Field[];

	constructor(data: any, hasActiveIndirect: boolean) {
		this.visible = ko.observable(true);
		this.id = data.operation.id || null;
		this.timecardEntry = data.timecardEntry || null;
		this.setupIsVisible = data.setupIsVisible != false;
		this.productionIsVisible = data.productionIsVisible != false;
		this.teardownIsVisible = data.teardownIsVisible != false;
		this.setupClass = this.buttonClass('success', hasActiveIndirect);
		this.productionClass = this.buttonClass(data.productionClass, hasActiveIndirect);
		this.teardownClass = this.buttonClass(data.teardownClass, hasActiveIndirect);
		this.displayWorkOrder = data.displayWorkOrder || null;
		this.setupUrl = data.setupUrl || null;
		this.productionUrl = data.productionUrl || null;
		this.teardownUrl = data.teardownUrl || null;
		this.stopUrl = data.stopUrl || null;
		this.infoUrl = appUrl(`~/ShopFloor/Operation/Info?i=${this.id}`);
		this.state = data.state || null;
		this.activeEmployees = data.activeEmployees || [];
		this.fields = data.fields || [];
	}

	showDetails() {
		showModalPage({
			url: this.infoUrl
		});
	}

	private buttonClass(name: string, isDisabled: boolean): string {
		var disabled = isDisabled ? 'disabled' : '';

		return `btn-${name} ${disabled}`;
	}
}
